import React from "react";
import PropTypes from "prop-types";
import { Typography, Grid } from "@mui/material";
import { isMobile } from "react-device-detect";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const TextosCarteleria = (props) => {
  const { insumos } = props;
  return (
    <Grid container  columns={12} >
      {insumos.map((insumo, index) => (
        <Grid xs={isMobile ? 12 : 4} key={index} mb='1rem' >
          <div
            style={{
              display: "flex",
              justifyContent: "center",             
              padding: ".5rem",
              flexDirection: "column",
              height: "12rem",
              width: "90%",
              border: "solid 1px rgba(207, 207, 207, 1)",
              borderRadius: "8px",
              boxShadow: "0 15px 35px  #6699ff",
              margin: '0 auto'
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  marginBottom: "1rem",
                  fontSize: "1rem",
                  textTransform: "uppercase",
                  textAlign: "start",
                }}
                gutterBottom
              >
                {insumo.titulo}
              </Typography>
              <CheckCircleOutlineIcon color="success" fontSize="large" />
            </div>
            <Typography
              variant="body-1"
              sx={{ marginBottom: "1rem", textAlign: "start" }}
              gutterBottom
            >
              {insumo.texto}
            </Typography>
          </div>
        </Grid>
      ))}
    </Grid>
  );
};

TextosCarteleria.propTypes = {
  insumos: PropTypes.shape({
    texto: PropTypes.string,
    titulo: PropTypes.string,
  }),
};

export default TextosCarteleria;
